import { createSlice } from '@reduxjs/toolkit';
import { getContainerStates } from 'ducks/container-states-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type ContainerStatesListState = ReturnType<
  typeof normalizeLookups<'container_state_name', 'container_state_id'>
>;

const initialState: ContainerStatesListState = [];

const containerStateListSlice = createSlice({
  name: Slices.CONTAINER_STATES_LIST,
  initialState,
  reducers: {
    clearContainerStatesList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContainerStates.pending, () => {
        return initialState;
      })
      .addCase(getContainerStates.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'container_state_name', 'container_state_id');
      })
      .addCase(getContainerStates.rejected, () => {
        return initialState;
      });
  },
});

export const { clearContainerStatesList } = containerStateListSlice.actions;

export default containerStateListSlice.reducer;
